/*
  Attar de Astana · Hairline header

  The panel under the bar words. A word with a submenu is a button: hover (with a mouse)
  or click opens the one shared panel, ArrowDown opens it and moves into it, Escape closes
  it and hands focus back to the word. Leaving the header, clicking outside, tabbing out
  or scrolling away closes it. Until this runs, those words are plain links, so nothing is
  lost with scripts off. The phone sheet is Dawn's MenuDrawer and is not touched here.
*/

(() => {
  const OPEN_DELAY = 80;
  const CLOSE_DELAY = 240;
  const wide = window.matchMedia('(min-width: 990px)');

  const init = (nav) => {
    if (nav.dataset.hairlineReady) return;
    nav.dataset.hairlineReady = 'true';

    const panel = nav.querySelector('[data-hairline-panel]');
    const triggers = Array.from(nav.querySelectorAll('[data-hairline-trigger]'));
    if (!panel || !triggers.length) return;

    const wrapper = nav.closest('.header-wrapper');
    const scrim = wrapper ? wrapper.querySelector('[data-hairline-scrim]') : null;
    let active = null;
    let openTimer = 0;
    let closeTimer = 0;
    let hoverOpenedAt = 0;
    let scrollAtOpen = 0;

    const setOpen = (trigger) => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      active = trigger;
      const open = Boolean(trigger);
      triggers.forEach((t) => t.setAttribute('aria-expanded', String(t === trigger)));
      panel.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      if (wrapper) wrapper.classList.toggle('is-hairline-open', open);
      if (open) scrollAtOpen = window.scrollY;
    };

    const close = (returnFocus) => {
      const last = active;
      if (!last) return;
      setOpen(null);
      if (returnFocus) last.focus();
    };

    const scheduleClose = () => {
      if (!active) return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => close(false), CLOSE_DELAY);
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        /* a click that lands just after hover opened the panel keeps it open */
        if (active === trigger && Date.now() - hoverOpenedAt > 600) {
          close(false);
        } else {
          setOpen(trigger);
        }
      });

      trigger.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        const open = () => {
          if (active !== trigger) hoverOpenedAt = Date.now();
          setOpen(trigger);
        };
        if (active) open();
        else openTimer = setTimeout(open, OPEN_DELAY);
      });

      trigger.addEventListener('pointerleave', () => clearTimeout(openTimer));

      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        setOpen(trigger);
        const first = panel.querySelector('a[href]');
        if (first) first.focus();
      });
    });

    /* pointing at a word without a submenu, the logo or the right side closes the panel */
    if (wrapper) {
      wrapper
        .querySelectorAll('.hairline-nav__word:not([data-hairline-trigger]), .header__heading-link, .header__icons')
        .forEach((el) => {
          el.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') scheduleClose();
          });
        });
      wrapper.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && active && event.target === wrapper) clearTimeout(closeTimer);
      });
      wrapper.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') scheduleClose();
      });
    }

    panel.addEventListener('pointerenter', () => clearTimeout(closeTimer));

    if (scrim) {
      scrim.addEventListener('click', () => close(false));
      /* the scrim sits inside the header, so pointing at the dimmed page never leaves it */
      scrim.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') scheduleClose();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !active) return;
      close(nav.contains(document.activeElement));
    });

    document.addEventListener('pointerdown', (event) => {
      if (active && !nav.contains(event.target)) close(false);
    });

    nav.addEventListener('focusout', () => {
      if (!active) return;
      setTimeout(() => {
        const focused = document.activeElement;
        if (focused && focused !== document.body && !nav.contains(focused)) close(false);
      });
    });

    window.addEventListener(
      'scroll',
      () => {
        if (active && Math.abs(window.scrollY - scrollAtOpen) > 80) close(false);
      },
      { passive: true }
    );

    wide.addEventListener('change', () => close(false));
  };

  const run = (root) => root.querySelectorAll('[data-hairline-nav]').forEach(init);
  run(document);
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
